import { request } from "@/interface/helper";

const str = "settingApi";

export const settingApi = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/api/list" }),
    add: (data) => request({ data, method: "post", url: "/api/add" }),
    detail: (data) => request({ data, method: "post", url: "/api/detail" }),
    edit: (data) => request({ data, method: "post", url: "/api/modify" }),
  },
};
